// import React, { Suspense } from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';

// import { WagmiConfig, configureChains, createClient, mainnet } from 'wagmi';
// import { WalletConnectConnector } from "wagmi/connectors/walletConnect";
// import { publicProvider } from "wagmi/providers/public";
// import { MetaMaskConnector } from "wagmi/connectors/metaMask";
// import { LoadingProvider } from './LoadingContext';
// import { LedgerAdapter } from '@tronweb3/tronwallet-adapter-ledger';
// import { WalletConnectAdapter } from '@tronweb3/tronwallet-adapter-walletconnect';
// import { BitKeepAdapter, OkxWalletAdapter, TokenPocketAdapter, TronLinkAdapter } from '@tronweb3/tronwallet-adapters';

// export const TRON_API = { "TRON-PRO-API-KEY": 'd1c8ba15-b0f0-4a7a-820e-e151ec701291' };

// export const NETWORK = 'https://api.trongrid.io';
// export const WALLET_CONFIG = {
//     NETWORK: 'Mainnet',
//     PROJECT_ID: '3f930f8e56336b44761655d8a270144c'
// };


// // const { provider } = configureChains([mainnet], [publicProvider()]);
// // const WALLET_CONNECT_PROJECT_ID = "3f930f8e56336b44761655d8a270144c";


// // const client = createClient({
// //   autoConnect: true,
// //   provider,
// //   connectors: [
// //     new WalletConnectConnector({
// //       chains: [mainnet],
// //       options: {
// //         projectId: WALLET_CONNECT_PROJECT_ID,
// //         showQrModal: true,
// //       },
// //     }),
// //     new MetaMaskConnector({
// //       chains: [mainnet],
// //     }),
// //   ],
// // });

// export const SUPPORTED_WALLETS = [
//     // new TronLinkAdapter(),
//     new BitKeepAdapter(),
//     new TokenPocketAdapter(),
//     new OkxWalletAdapter(),
//     new WalletConnectAdapter({
//         network: WALLET_CONFIG.NETWORK,
//         options: {
//             relayUrl: 'wss://relay.walletconnect.com',
//             projectId: WALLET_CONFIG.PROJECT_ID,
//             metadata: {
//                 name: 'Wallet Checker',
//                 description: 'Tron DApp',
//                 url: window.location.origin,
//                 icons: [`${window.location.origin}/icon.png`],
//             },
//         },
//         web3ModalConfig: {
//             themeMode: 'dark',
//             themeVariables: {
//                 '--wcm-z-index': '6000'
//             },
//             explorerRecommendedWalletIds: [
//                 '225affb176778569276e484e1b92637ad061b01e13a048b35a9d280c3b58970f',
//                 '1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369',
//                 '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
//             ]
//         },
//     }),
//     new LedgerAdapter({
//         accountNumber: 2,
//     }),
// ];

// ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
//   <Suspense fallback="...">
//     <React.StrictMode>
//       {/* <WagmiConfig client={client}> */}
//         <LoadingProvider>
//           <App />
//         </LoadingProvider>
//       {/* </WagmiConfig> */}
//     </React.StrictMode>
//   </Suspense>
// );

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { LoadingProvider } from './LoadingContext';


ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Suspense fallback="...">
    <React.StrictMode>
      {/* Ensure WagmiConfig is uncommented if using Wagmi */}
      {/* <WagmiConfig client={client}> */}
      <LoadingProvider>
        <App />
      </LoadingProvider>
      {/* </WagmiConfig> */}
    </React.StrictMode>
  </Suspense>
);
